import React, { FC, useState } from 'react';
import { Snackbar } from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

interface SnackbarOrigin {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
}
interface Props {
    message: string;
    open: boolean;
    severity: "success" | "info" | "warning" | "error" | undefined;
    className?: string;
    style?: React.CSSProperties;
    position?: SnackbarOrigin;
    hideDuration?: number | null | undefined;
}

const Alert = (props: AlertProps) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const SnackBarAlert: FC<Props> = (p) => {

    const [open, setOpen] = useState(p.open);

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    return (
            <Snackbar
                anchorOrigin={p.position} 
                open={open} 
                autoHideDuration={p.hideDuration} 
                onClose={handleClose}
                className={p.className}
                style={p.style}
            >
                <Alert onClose={handleClose} severity={p.severity}>
                    {p.message}
                </Alert>
            </Snackbar>
    );
};

export default SnackBarAlert;
